
import { defineComponent } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  props: {
    icon: {
      type: String,
      default: "icon-message.png",
    },
    text: {
      type: String,
      default: "",
    },
    command: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { dispatch, commit } = useStore()
    const iconSRC = require("@/assets/" + props.icon)
    const executeButton = (command: string) => {
      switch (command) {
        case "sendMessage":
          dispatch("callgate/callMessage")
          break
        case "talkPhone":
          dispatch("callgate/callTelephone")
          break
        case "failConnect":
          commit("complete/SET_ISDIALOG_OPEN", true)
          break
        case "clearCarCheck":
          commit("autocall/SET_ISCARCHECKED", false)
          break
        case "callLastHistory":
          dispatch("callgate/callLastHistory")
          break
        case "reflash":
          dispatch("callgate/startVARS")
          break
        case "confirmCall":
          dispatch("warning/openWarning", { message: "직접 통화하기는 상대방에게 내 전화번호가 표시됩니다. 계속 하시겠습니까?"
            , buttonText: "취소", processButtonText: "통화요청" }, { root: true })
          break
        default:
          alert("입력값없음")
          break
      }
    }

    return {
      iconSRC,
      executeButton,
    }
  },
})
